import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { columbiaSCConfig } from "./data";

export default function ColumbiaSCPage() {
  return <CityPageTemplate config={columbiaSCConfig} />;
}